import { IconContent } from '@icons';

export const caretUpFilled: IconContent = {
    sm: '<path fill-rule="evenodd" clip-rule="evenodd" d="M12 9.53452L8.30769 6H7.69231L4 9.53452V10L12 10V9.53452Z"/>',
    md: '<path d="M12.5563 7.98227L19.0178 14.9408L19.0178 16.0178H5.01782V14.9408L11.4794 7.98227L12.5563 7.98227Z"/>',
};
